import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import Draggable from 'react-draggable';

import map from 'lodash/map';
import forEach from 'lodash/forEach';
import find from 'lodash/find';

import config from './config.json';
import TimezoneItem from './timezone';
import ModalBox from '../../../shared/modal';

lessRequire('modules/profile/components/timezones-map/map.less');

const propTypes = {
	activeZone: PropTypes.string,
	onChoose: PropTypes.func,
	timezones: PropTypes.array,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	title: PropTypes.string
};

const defaultProps = {
	activeZone: 'Europe/Moscow'
};

class Map extends React.Component {
	constructor(props) {
		super(props);
		const initialState = {
			activeZone: props.activeZone,
			scale: 1,
			maxScale: 2,
			isDragging: false,
			defaultMapPosition: { x: 0, y: 0 },
			onClickMouseWasMoved: false,
			mousePosX: null,
			mousePosY: null
		};
		this.state = initialState;
	}

	handleDragStart(e) {
		this.setState({
			isDragging: true,
			onClickMouseWasMoved: false,
			mousePosX: e.clientX,
			mousePosY: e.clientY
		});
	}

	handleDragStop(e) {
		if (this.state.mousePosX != e.clientX && this.state.mousePosY != e.clientY) {
			this.setState({ onClickMouseWasMoved: true });
		}
		this.setState({ isDragging: false });
	}

	zoomIn() {
		this.setState({ scale: 2 });
	}

	zoomOut() {
		this.setState({
			scale: 1,
			defaultMapPosition: { x: 0, y: 0 }
		});
	}

	setZones(zone) {
		const x = (180 + zone.long) / 360;
		const y = (90 - zone.lat) / 180;

		const left = x * 100 + '%';
		const top = y * 100 + '%';

		const isActive = this.state.activeZone === zone.name;

		return <TimezoneItem key={zone.name} left={left} top={top} isActive={isActive} />;
	}

	activeZoneDetect(e) {
		const { width, height, left, top } = this.$mapWrap.getBoundingClientRect();
		const offsetX = (e.nativeEvent.clientX - left) / width;
		const offsetY = (e.nativeEvent.clientY - top) / height;

		const getZoneActiveCovering = (zoneX, zoneY, offsetX, offsetY) =>  {
			const dx = zoneX - offsetX;
			const dy = zoneY - offsetY;
			return dx * dx + dy * dy;
		};

		let closestZoneDist = 100, closestZoneName;

		forEach(config.zones, zone => {
			const x = (180 + zone.long) / 360;
			const y = (90 - zone.lat) / 180;
			const zoneActiveCovering = getZoneActiveCovering(x, y, offsetX, offsetY);

			if (zoneActiveCovering < closestZoneDist) {
				closestZoneName = zone.name;
				closestZoneDist = zoneActiveCovering;
			}
		});

		if (closestZoneName) {
			this.setState({
				activeZone: closestZoneName
			});
		}
	}

	getTimezoneIntlName(timezone) {
		const result = find(this.props.timezones, { value: timezone });
		return result.label || timezone;
	}

	renderBody() {
		return (
			<div className="timezones-container">
				<h2>{this.getTimezoneIntlName(this.state.activeZone)}</h2>
				<div className="timezones-container__map">
					<div className={cn('timezones-container__map-outer', `scale-${this.state.scale}`)}>
						<Draggable
							handle=".timezones-container__map-inner"
							bounds={this.state.scale > 1 ? { top: -120, left: -275, right: 275, bottom: 120 } : 'parent'}
							defaultPosition={this.state.defaultMapPosition}
							position={this.state.scale === 1 ? this.state.defaultMapPosition : null}
							onStart={e => this.handleDragStart(e)}
							onDrag={this.handleDrag}
							onStop={e => this.handleDragStop(e)}>
							<div
								className={cn('timezones-container__map-inner')}
								ref={e => this.$mapWrap = e}
								onClick={e => !this.state.onClickMouseWasMoved && this.props.onChoose(this.state.activeZone)}
								onMouseMove={!this.state.isDragging && this.activeZoneDetect.bind(this)}
								onWheel={(e) => {
									e.preventDefault();
									if (e.deltaY < 0) {
										this.zoomIn();
									}
									if (e.deltaY > 0) {
										this.zoomOut();
									}
								}}
							>
								{ map(config.zones, zone => this.setZones(zone)) }
							</div>
						</Draggable>
					</div>
				</div>
				<div className="zoom-btns">
					<div onClick={this.zoomIn.bind(this)} className="zoom-in">+</div>
					<div onClick={this.zoomOut.bind(this)} className="zoom-out">-</div>
				</div>
			</div>
		);
	}

	render() {
		return (<ModalBox
			className="modal-overlay__content timezone-modal"
			isOpen={this.props.isOpen}
			onClose={() => this.props.onClose()}
			closeOnOverlayClick={false}
			title={this.props.title}>
			{this.renderBody()}
		</ModalBox>);
	}
}

Map.propTypes = propTypes;
Map.defaultProps = defaultProps;
export default Map;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/timezones-map/map.js